import APIV5 from '~/models/api';
import angular from 'angular';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import FileUpload from '~/scripts/services/model/file-upload';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import InspectModule from '~/scripts/providers/templateCompilerGetPlaceholders';

/* globals Knitiv */

export default class TemplateExportNewController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').IQService} $q
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').ISCEService} $sce
	 */
	constructor(
		$injector,
		$rootScope,
		$scope,
		$q,
		$location,
		$sce,
	) {
		const TEMPLATE_KID = 'K_NODE;KEXPTPLT';

		const docxTemplater = new Docxtemplater();
		const indexModule = new InspectModule();

		$scope.selectedFile = null;
		$scope.tags = null;
		$scope.sourceMF = [];
		$scope.source = null;
		$scope.doc = null;
		$scope.templateName = '';
		$scope.currentTemplate = {};

		$scope.associations = {};

		$scope.tooltipHelpMessage = $sce.trustAsHtml(`
	<span>Les variables sont représentées entre accolades: "{ma_variable}"</span>
	<span>Les répétitions sont représentées de cette maniere: "{#ma_variable} {mon_sous_élément} {/ma_variable}"</span>
`);

		$scope.queryStrings = $location.search();
		$scope.isEditMode = !!$scope.queryStrings.kid;
		$scope.editKid = $scope.isEditMode ? $scope.queryStrings.kid : null;

		// OnLoad

		// Prepare view for edition
		if ($scope.isEditMode) {
			// Get infos about current template
			APIV5.instance.objectInfo({ kid: $scope.editKid }, { id: 'template-export-new.current-template' })
				.then(template => {
					$scope.currentTemplate = template;

					// Get JSON
					const kjson = template.kjson ? JSON.parse(template.kjson) : null;

					$scope.currentTemplate.kjson = kjson;

					return APIV5.instance.objectInfo({ kid: kjson.source.kid }, { id: 'template-export-new.source' });
				})
				.then(source => {
					// Restore MF
					$scope.sourceMF = [{
						isa: 'K_NODE;SYS_CLASSE',
						isa_name: 'CLASSE',
						kid: source.objid,
						name: source.objname,

						node: source.objid,
						type: source.type_kid,
					}];

					// Restore source
					// TODO
					$scope.source = source;
					$scope.source.kid = source.objid;

					// Say we already have a doc
					$scope.doc = true;

					// Restore template name
					$scope.templateName = $scope.currentTemplate.objname;

					// Restore tags
					$scope.tags = $scope.currentTemplate.kjson.tags;

					// Restore associations
					// eslint-disable-next-line unicorn/prefer-object-from-entries,unicorn/no-array-reduce
					$scope.associations = Object.entries($scope.currentTemplate.kjson.links).reduce((
						/** @type {any} */ array,
						/** @type {any} */ value,
					) => {
						const key = value[0];
						const v = value[1];

						array[key] = {};
						array[key].link = [v];

						if (v.childs) {
							array[key].childs = v.childs;

							for (const data of Object.entries(array[key].childs)) {
								const childKey = data[0];
								const childValue = data[1];
								array[key].childs[childKey] = {
									link: [childValue],
									childs: {},
								};
							}
						}

						return array;
					}, {});

					// $scope.setupAssociations($scope.tags);
					// $scope.doc = true;
					return true;
				})
				.catch(error => console.error(error));
		}

		// Delete an association
		$scope.deleteAssociation = (
			/** @type {string | number} */ firstLevelName,
			/** @type {string | number} */ secondLevelName,
		) => {
			if (secondLevelName) {
				$scope.associations[firstLevelName].childs[secondLevelName].link = [];
			}
			else {
				$scope.associations[firstLevelName].link = [];
			}
		};

		// When the sourceMF change, set source to the new item
		$scope.onSourceChanged = (/** @type {any} */ item) => {
			// todo why I need that ?
			// it's required for "output" block to work !
			$scope.sourceMF[0].node = item.kid;
			$scope.sourceMF[0].type = item.type || item.type_kid || item.isa;

			$scope.source = item;
		};

		// Get links from associations
		$scope.getLinks = (/** @type {any} */ input) => {
			/** @type {any} */
			const links = {};
			for (let index = 0; index < Object.keys(input).length; index++) {
				// key = nom du champs (code_postal)
				const key = Object.keys(input)[index];
				links[key] = input[key].link[0];

				// check that parent exist, childs exist and child length > 0
				if (input[key] && links[key] && input[key].childs && Object.keys(input[key].childs).length > 0) {
					links[key].childs = $scope.getLinks(input[key].childs);
				}
			}

			return links;
		};

		// Get tags from scope tags
		$scope.getTags = () => angular.copy($scope.tags);

		// Build items for objectCreate
		$scope.getItems = (
			/** @type {any} */ links,
			/** @type {any} */ tags,
			/** @type {boolean | undefined} */ addFile,
		) => {
			if (addFile === undefined) {
				// eslint-disable-next-line no-param-reassign
				addFile = true;
			}

			// JSON generation
			const json = {
				source: {
					kid: $scope.source.kid,
				},
				links,
				tags,
			};

			// ---

			return [
				{
					target_objnum: 'K_NODE;_NR_TEMPLATE_EXPORT',
					OBJECT_LIST:   {
						'K_NODE;_NR_TEMPLATE_EXPORT': {
							LINK_LIST:  {
								[COMPOSED_OF]: [
									{
										class_kid:  'K_NODE;ANYTHING',
										linker_kid: '0',
										objnum2:    $scope.source.kid,
										action:     'ADD',
									},
								],
							},
							isa:        TEMPLATE_KID,
							REPRE_LIST: [
								{
									name: $scope.templateName,
									lang: 'K_NODE;UNIVERSEL',
								},
							],
							fileid:     addFile ? $scope.tmpFile.id : null,
							kjson:      JSON.stringify(json),
						},
					},
				},
			];
		};

		// Build items for object modify
		$scope.getItemsUpdate = (
			/** @type {any} */ links,
			/** @type {any} */ tags,
			/** @type {boolean | undefined} */ addFile,
		) => {
			if (addFile === undefined) {
				// eslint-disable-next-line no-param-reassign
				addFile = true;
			}

			// JSON generation
			const json = {
				source: {
					kid: $scope.source.kid,
				},
				links,
				tags,
			};

			// ---

			return [
				{
					target_objnum: $scope.editKid,
					OBJECT_LIST:   {
						[$scope.editKid]: {
							isa:        TEMPLATE_KID,
							LINK_LIST:  {
								[COMPOSED_OF]: [{
									action:     'REP',
									objnum2:    $scope.source.kid,
									class_kid:  'K_NODE;ANYTHING',
									linker_kid: '0',
								}],
							},
							REPRE_LIST: [
								{
									name: $scope.templateName,
									lang: 'K_NODE;UNIVERSEL',
								},
							],
							fileid:     addFile ? $scope.tmpFile.id : null,
							kjson:      JSON.stringify(json),
						},
					},
				},
			];
		};

		// upload and save the new template
		$scope.save = () => {
			$scope.tmpFile = new FileUpload($injector, $scope.selectedFile, `${$scope.templateName}.docx`);

			$scope.tmpFile.upload()
				.then(() => {
					const links = $scope.getLinks($scope.associations);
					const tags = $scope.getTags();
					const items = $scope.getItems(links, tags);

					return APIV5.instance.objectCreate({ items }, { id: 'template-export-new.save' });
				})
				.then(() => $location.path('/template-export'))
				.catch((/** @type {any} */ error) => console.error(error));
		};

		// Update an existing template
		$scope.update = () => {
			const callback = (/** @type {boolean} */ addFile) => {
				const links = $scope.getLinks($scope.associations);
				const tags = $scope.getTags();

				const items = $scope.getItemsUpdate(links, tags, addFile);

				return APIV5.instance.objectModify({ items }, { id: 'template-export-new.update' })
					.then(() => $location.path('/template-export'));
			};

			if ($scope.selectedFile) {
				$scope.tmpFile = new FileUpload($injector, $scope.selectedFile, `${$scope.templateName}.docx`);
				$scope.tmpFile.upload()
					// eslint-disable-next-line promise/no-callback-in-promise
					.then(() => callback(true))
					.catch((/** @type {any} */ error) => console.error(error));
			}
			else {
				callback(false);
			}
		};

		// Prepare associations from tags
		$scope.setupAssociations = (/** @type {any} */ tags) => {
			$scope.associations = {};
			for (const tag of tags) {
				// if (!$scope.associations[tag.placeholder]) {
				$scope.associations[tag.placeholder] = {
					link: [],
					childs: {},
				};

				if (tag.type === 'loop') {
					for (let index = 0; index < tag.childs.length; index += 1) {
						const child = tag.childs[index];
						$scope.associations[tag.placeholder].childs[child.placeholder] = {
							link: [],
							childs: [],
						};
					}
				}
				// }
			}
		};

		$scope.readFileTags = (/** @type {Blob} */ file) => $q((/** @type {Function} */ resolve) => {
			const reader = new FileReader();
			reader.addEventListener('load', () => {
				if (reader.result) {
					const zip = new PizZip(reader.result);
					$scope.doc = docxTemplater.loadZip(zip);
					$scope.doc.attachModule(indexModule);
					$scope.doc.compile();
					const tags = indexModule.getAllTags();

					resolve(tags);
				}
			});
			reader.readAsArrayBuffer(file);
		});

		// When a file is selected, load it, parse it and setup tags and associations
		$scope.$watch('selectedFile', (/** @type {any} */ file) => {
			if (file) {
				$scope.readFileTags(file)
					.then((/** @type {any} */ tags) => {
						$scope.tags = tags;
						return $scope.setupAssociations(tags);
					})
					.catch((/** @type {any} */ error) => console.error(error));
			}
		});

		// $scope.$watch('associations', () => {
		// 	console.log($scope.associations);
		// }, true);
	}
}
